// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"oX","backgroundimage":"pX","header":"qX","headerwrap":"rX","title":"sX","promomessage":"tX","upsellItem":"uX","upsellImg":"vX","helperText":"wX","upsellHeadline":"xX","price":"yX","upsellGross":"zX","upsellNet":"AX","upsellButton":"BX","nutritionfacts":"CX","nutritionimg":"EX","containerwhy":"FX","nutritionwrappwer":"GX","headlinewhy":"HX","boxwhy":"IX","textwhy":"JX","backbutton":"KX","drawercontainer":"LX","logoheader":"MX","textwrap":"NX","timer":"OX"};
    if(module.hot) {
      // 1737143664804
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  